module.exports = __webpack_public_path__ + "img/ace_card.c9402c4.svg";